import { useState } from 'react'

import { Banner, Banners, BroadbandPlanMember } from '@giffgaff/broadband-common'

import { useRouter } from 'next/router'

import { ProfileOrder } from '@/api'

import { SwitchDetailsModal } from '../SwitchDetailsModal'

export type TBannersProps = {
  banners: Banner[] | undefined
  errorMessage: string | undefined
  dismissCallback: (bannerId: string) => void
  showAgentChat: () => void
  plan?: BroadbandPlanMember
  order?: ProfileOrder
}

export const BannersWithActions = ({
  banners,
  errorMessage,
  dismissCallback,
  showAgentChat,
  plan,
  order,
}: TBannersProps) => {
  const [otsModalOpen, setOTSModalOpen] = useState(false)
  const router = useRouter()
  const [localError, setLocalError] = useState<string | undefined>(undefined)

  const actionCallback = (actionName: string) => {
    switch (actionName) {
      case 'otsModal':
        setOTSModalOpen(true)
        break
      case 'agentChat':
        showAgentChat()
        break
      case 'manageInstall':
        if (order?.id) {
          router.push(`manage-order/change-install-dates/${order.id}`)
        } else {
          setLocalError('There was a problem retrieving your order details. Please refresh the page.')
        }

        break
      default:
        break
    }
  }

  return (
    <>
      <Banners
        actionCallback={actionCallback}
        banners={banners}
        dismissCallback={dismissCallback}
        errorMessage={localError ? localError : errorMessage}
        isMSA={false}
      />

      <SwitchDetailsModal handleClose={() => setOTSModalOpen(false)} isOpen={otsModalOpen} plan={plan} />
    </>
  )
}
